<div class="_content"
     [dfs]="'bg:w br:4px p-v:4px'">
    <div [dfs]="'p-a:4px'"
         ngForm>
        <icms-form-field [sideIcon]="icons.Search">
            <input [dfs]="'h:48px d:block'"
                   style="border-color:transparent"
                   type="text"
                   name="search"
                   placeholder="Type a command or &quot;/&quot; to search content"
                   autocomplete="off"
                   #input
                   [(ngModel)]="query"
                   (keyup)="onKey($event)"
                   (ngModelChange)="onSearchChange()" />
        </icms-form-field>
    </div>
    <div [dfs]="'b-t:1px bc:14 p-v:12px br:2px max-height:300px o-y:auto'">
        @switch(mode){
        @case('search') {
        <icms-shortcuts-search [query]="query"></icms-shortcuts-search>
        }
        @case('default') {
        @if(results.length > 0) {
        @for(result of results; track $index; let isFirst = $first){
        <h3 [dfs]="'t:s1 p-v:2 p-h:20px'">{{result.title}}</h3>
        @for(child of result.children; track $index){
        <button [dfs]="'d:flex flex-justify-content:space-between w:100% p-v:2 p-h:19px'"
                class="_item"
                [class._busy]="child.status?.busy"
                [class._selected]="isSelected(child)"
                (mouseenter)="select(child)"
                (click)="apply(child, $event)">
            <p [dfs]="'t:p1 ta:left'"
               class="_line">
                <span>{{child.command}}</span>
                @if(child.info) {
                <span [dfs]="'c:14'"> - {{child.info}}</span>
                }
            </p>
            @if(child.status?.busy) {
            <icms-loader></icms-loader>
            }
        </button>
        }
        }
        }
        @else {
        <icms-hint-banner>There are no commands matching query.</icms-hint-banner>
        }
        }
        }
    </div>
</div>